import { createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../utilities/BASE_URL';
import { postWithToken } from '../utilities/fetchWithToken';

const postPup = (type, path, fallback, shape = (data, arg) => ({ ...arg, ...data })) =>
  createAsyncThunk(type, async (arg, { rejectWithValue }) => {
    try {
      const response = await postWithToken(`${BASE_URL}${path}`, arg);
      if (!response.ok) return rejectWithValue((await response.text()) || fallback);
      return shape(await response.json(), arg);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

const privateShape = (data, arg) => ({
  roomId: arg.roomId,
  holeCards: data.holeCards,
  handInfo: data.handInfo,
  pupCards: data.pupCards,
  pupCardInstances: data.pupCardInstances,
  stagedPupCards: data.stagedPupCards,
  stagedCommitted: data.stagedCommitted,
  queuedPupCards: data.queuedPupCards,
  lockedPupCards: data.lockedPupCards,
  exchangeRateTwo: data.exchangeRateTwo,
});

export const playPupCard = postPup(
  'pup/playCard', '/games/playpupcard', 'Failed to play Power-Up card', privateShape);
export const pickPupTarget = postPup(
  'pup/pickTarget', '/games/puptarget', 'Failed to pick a target');
export const pickPupDiscard = postPup(
  'pup/pickDiscard', '/games/pupdiscard', 'Failed to pick a discard');
// Swiper's cost pick: one of the caller's OWN held pup cards (a CODE, not a hole token) —
// the play then moves to its ordinary targeting window.
export const pickPupHandDiscard = postPup(
  'pup/pickHandDiscard', '/games/puphanddiscard', 'Failed to discard a Power-Up card');
export const pickPupCardTarget = postPup(
  'pup/pickCardTarget', '/games/pupcardtarget', 'Failed to pick a card');
export const multiDiscardPupCards = postPup(
  'pup/multiDiscard', '/games/pupmultidiscard', 'Failed to exchange cards');
export const buryPupCard = postPup(
  'pup/buryCard', '/games/pupbury', 'Failed to bury a card');
export const performPupTrick = postPup(
  'pup/performTrick', '/games/puptrick', 'Failed to perform the trick');
export const pickPupOptIn = postPup(
  'pup/optIn', '/games/pupoptin', 'Failed to join the Power-Up');
export const pickPupValue = postPup(
  'pup/pickValue', '/games/pupvalue', 'Failed to name a value');
export const votePupPlay = postPup(
  'pup/vote', '/games/pupvote', 'Failed to vote');
export const pickContractSeat = postPup(
  'pup/pickContractSeat', '/games/puppick', 'Failed to pick a player');
export const sniperGuess = postPup(
  'pup/sniperGuess', '/games/pupguess', 'Failed to guess');
export const stagePupCard = postPup(
  'pup/stageCard', '/games/pupstage', 'Failed to stage card', privateShape);
export const unstagePupCard = postPup(
  'pup/unstageCard', '/games/pupunstage', 'Failed to unstage card', privateShape);
// The AUTO-PLAY box: queueing a card hands it to the server, which plays it at the next moment
// it is legally playable — including immediately, if it already is.
export const queuePupCard = postPup(
  'pup/queueCard', '/games/pupqueue', 'Failed to queue card', privateShape);
export const unqueuePupCard = postPup(
  'pup/unqueueCard', '/games/pupunqueue', 'Failed to unqueue card', privateShape);
